import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UnauthorizedAccessService {
  private isFromGuard = false;

  setFromGuard(value: boolean): void {
    this.isFromGuard = value;
  }

  checkAndResetFromGuard(): boolean {
    const value = this.isFromGuard;
    this.isFromGuard = false; // Reset after check
    return value;
  }
}
